import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63f3308b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "footer__github",
  href: "https://github.com/stalanov/rick-and-morty-ui-vue",
  target: "_blank"
}

import { NLayoutFooter, NIcon } from 'naive-ui';
import { LogoGithub } from '@vicons/carbon';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const year = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NLayoutFooter), {
    class: "footer",
    bordered: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, _toDisplayString(_unref(year)) + " — Rick and Morty UI — Vue.Js", 1),
      _createElementVNode("a", _hoisted_1, [
        _createVNode(_unref(NIcon), {
          size: 22,
          component: _unref(LogoGithub)
        }, null, 8, ["component"])
      ])
    ]),
    _: 1
  }))
}
}

})